module.exports = __webpack_public_path__ + "img/home.c861d850.png";